import { MoreOutlined } from '@ant-design/icons'
import { Button, Dropdown, Menu } from 'antd'

import { renderDateColumn, renderPrincipalColumn } from '../../../components/tables'
import {
  buildSearchFilterProps,
  sortDateColumn,
  sortNumericColumn,
  sortStringColumn,
} from '../../../components/tables/utils'
import { BespokeRating } from './models'

const renderActionsMenu =
  ({ onDelete, onUpdate }: { onDelete: (rating: BespokeRating) => void; onUpdate: (rating: BespokeRating) => void }) =>
  (_: any, rating: BespokeRating) => {
    const menu = (
      <Menu>
        <Menu.Item key="updateBespokeRating" onClick={() => onUpdate(rating)}>
          Update Bespoke Rating
        </Menu.Item>
        <Menu.Item key="deleteBespokeRating" onClick={() => onDelete(rating)}>
          Delete Bespoke Rating
        </Menu.Item>
      </Menu>
    )

    return (
      <Dropdown placement="bottomRight" overlay={menu}>
        <Button icon={<MoreOutlined />} />
      </Dropdown>
    )
  }

export const bespokeRatingsTableColumns = ({
  onDelete,
  onUpdate,
}: {
  onDelete: (group: BespokeRating) => void
  onUpdate: (group: BespokeRating) => void
}) => [
  {
    title: 'ID',
    dataIndex: 'id',
    sorter: sortNumericColumn({ dataIndex: 'id' }),
    ...buildSearchFilterProps({ dataIndex: 'id' }),
  },
  {
    title: 'Banking Group',
    dataIndex: 'bankingGroup',
    sorter: sortStringColumn({ dataIndex: 'bankingGroup' }),
  },
  {
    title: 'Start Date',
    dataIndex: 'startDate',
    render: renderDateColumn,
    sorter: sortDateColumn({ dataIndex: 'startDate' }),
  },
  {
    title: 'Max Short Limit',
    dataIndex: 'maxLimitShort',
    sorter: sortNumericColumn({ dataIndex: 'maxLimitShort' }),
  },
  {
    title: 'Max Long Limit',
    dataIndex: 'maxLimitLong',
    sorter: sortNumericColumn({ dataIndex: 'maxLimitLong' }),
  },
  {
    title: 'Max Short Money Limit',
    dataIndex: 'maxMoneyLimitShort',
    sorter: sortNumericColumn({ dataIndex: 'maxMoneyLimitShort' }),
    render: renderPrincipalColumn,
  },
  {
    title: 'Max Long Money Limit',
    dataIndex: 'maxMoneyLimitLong',
    sorter: sortNumericColumn({ dataIndex: 'maxMoneyLimitLong' }),
    render: renderPrincipalColumn,
  },
  { title: '', render: renderActionsMenu({ onDelete, onUpdate }) },
]
